export const accountLabels = {
    coverageTiers: [
        { id: "Single", name: "Single", displayAlways: true},
        { id: "Spouse", name: "Enrollee and Spouse", displayAlways: false },
        { id: "Child", name: "Enrollee and Children", displayAlways: false },
        { id: "Family", name: "Family", displayAlways: true },
    ],
    lifeEventTypes: [
        { id: "Marriage", name: 'Marital Status' },
        { id: "Divorce", name: 'Marital Status - Dissolution of Marriage' },
        { id: "DependentAdd", name: 'Dependent - Added' },
        { id: "DependentEligibilityChange", name: 'Dependent - Eligibility Change' },
        { id: "DependentSpouseCoverageChange", name: 'Dependent - Spouse Coverage Change' },
        { id: "DependentChildCoverageChange", name: 'Dependent - Child(ren) Coverage Change' },
        { id: "DependentCustodyChange", name: 'Dependent - Custody Change' },
        { id: "DependentDeath", name: 'Dependent - Death' },
        { id: "EmployementStatusChange", name: 'Employment Status Change' },
        { id: "FMLA", name: 'Family Medical Leave' },
        { id: "QualifiedMedicalChildSupportOrder", name: 'Qualified Medical Child Support Order' },
    ],
    cipStatuses :[
        { id: 0, name: 'Not Applicable' },
        { id: 1, name: 'Pending' },
        { id: 2,
          name: 'Approved',
          format: (acc) => {
            return `Approved (${moment(acc.cipApprovalDate).format('MM/DD/YYYY')})`;
          }
        },
        { id: 3, name: 'Rejected' },
        { id: 4, name: 'Failed' },
        { id: 5, name: 'Documentation Requested' },
        { id: 6, name: 'Documentation Received' }
    ],
    getStatusDisplayText(status) {
        var accountStatuses = {
            0: 'Unknown',
            1: 'New',
            2: 'Active',
            3: 'Temp Inactive',
            4: 'Perm Inactive',
            5: 'Terminated'
        };

        return accountStatuses[status];
    },
    getCipStatusDisplayText(cipStatusId, cipApprovalDate){
        let status = this.cipStatuses.find(status => status.id == cipStatusId);
        return status.format ? status.format({ cipStatusId, cipApprovalDate }) : status.name;
    },
    status: {
        terminated: 5,
        permInactive: 4,
        tempInactive: 3,
        active: 2,
        new: 1,
        unknown: 0,
    }
}



// WEBPACK FOOTER //
// ./src/accounts/account-labels.js